import {useId} from 'react';

import {BannerPlacementType} from '../types';

export const useBannerContainerId = (
  placement: BannerPlacementType,
  position?: number,
) => {
  const id = useId();

  return ['yan', placement, position, id]
    .filter(Boolean)
    .join('_')
    .replace(':', '');
};
